module.exports = __webpack_public_path__ + "static/img/6areaB_1.0297398.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_1.png
// module id = 1202
// module chunks = 1